import moment from 'moment';
import React, { useState } from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';
import { IconContext } from 'react-icons';
import { MdSettings } from 'react-icons/md';
import TableHeader from '../components/TableHeader';
import Paginations from '../Pagination/Pagination';
import DataOfferInterface from '../../../interface/reducers/offer';
import { convertToRupiah, handlePaymentMethodText } from '../../../utils';
import { ModalWalletLog } from '../Modals';
import NotesCredit from './NotesCredit';
import EmptyList from '../../../images/no-transaction.png';

export interface Details {
  id: number;
  dataBank: null;
  totalAmount: number;
  disbursementNumber: null;
  type: null;
  created_at: string;
  note: string | null;
  paymentMethod: string;
  paymentVia: string;
  invoiceNumber: string;
  bankAccount: string[];
  invoiceUrl: string;
  expiredPayment: boolean;
  fee: number;
}

function BodyTab({
  title,
  icon,
  data,
  type,
  history,
  onRefreshList,
  activeTabs,
  paginationEachTab,
  checkPageTab,
  handleGoto,
  RenderPagination,
  isFetching,
}) {
  const [isModalDetailOpened, setModalDetailOpened] = useState(false);
  const toggleModalDetail = () => setModalDetailOpened(!isModalDetailOpened);
  const [Details, setDetails] = useState<Details | {}>({});
  function renderItem(item): JSX.Element {
    const handleClickedDetail = () => {
      setDetails({
        id: item.id,
        type: type !== 'TOPUP' ? item.type : 'TOPUP',
        disbursementNumber: item.disbursement_number,
        totalAmount: item.total_amount,
        dataBank: item.disbursement_bank,
        created_at: item.created_at,
        note: item.note,
        paymentMethod: item.payment_method,
        paymentVia: item.payment_via,
        invoiceNumber: item.invoice_number,
        bankAccount: item.account_banks,
        invoiceUrl: item.invoice_url,
        expiredPayment: item.expired,
        fee: item.fee,
        status: item.status,
      });
      toggleModalDetail();
    };
    const invoiceNumber =
      type !== 'TOPUP' ? item.disbursement_number : item.invoice_number;
    const isUnverified =
      item.status.replace(/[_]/g, ' ').toUpperCase() === 'UNVERIFIED';
    const isRejected =
      item.status.replace(/[_]/g, ' ').toUpperCase() === 'REJECTED';
    const isExpired = isUnverified && item.is_expired;

    const getStatusText = () => {
      if (item.status.replace(/[_]/g, ' ').toUpperCase() === 'NEW') {
        return 'PENDING';
      }
      if (isExpired) {
        return 'EXPIRED';
      }
      return item.status.replace(/[_]/g, ' ').toUpperCase();
    };

    const getStatusStyle = () => {
      if (isExpired) return { color: '#8d8d8d' };
      if (isUnverified || isRejected) return { color: '#e02020' };
      return {};
    };

    return (
      <div key={item.id} className={'item-table'}>
        <div className={'product-container'}>
          <div>
            {type === 'WALLET_LOGS' ? (
              <p
                style={{
                  color: item.type === 'BALANCE_IN' ? '#159953' : '#dc3545',
                }}
              >
                {item.type.replace(/[_]/g, ' ').toUpperCase()}
              </p>
            ) : null}
            <p className={'title'}>{invoiceNumber}</p>
          </div>
        </div>
        <div className={'expiry-container'}>
          <span>{moment(item.created_at).format('MMMM DD, YYYY')}</span>
        </div>
        <div className={'status-inprogress-container'}>
          <div className={'price-container'}>
            {type === 'TOPUP' ? (
              <div>
                <p className={'payment-method-text'}>
                  {handlePaymentMethodText(
                    item.payment_method,
                    item.payment_via,
                    item.bank_code,
                  )}
                </p>
                <span onClick={() => openPaymentConfirm(item)}>
                  Payment Confirmation
                </span>
              </div>
            ) : (
              /*
                INI UNTUK TAMPILKAN STATUS HANYA UNTUK WALLET_LOGS
                (
                  type === 'WALLET_LOGS' ?
                  <p>{item.status.replace(/[_]/g,' ').toUpperCase()}</p>
                  :
                  null
                )
                */
              <p style={getStatusStyle()}>{getStatusText()}</p>
            )}
            <span style={getStatusStyle()}>
              IDR {convertToRupiah(item.total_amount.slice(0, -3))}
            </span>
          </div>
          <div className={'button-container'}>
            <IconContext.Provider value={{ color: '#242424', size: '15px' }}>
              <div className={'icon-container'} onClick={handleClickedDetail}>
                <MdSettings />
              </div>
            </IconContext.Provider>
          </div>
        </div>
      </div>
    );
  }

  function renderEmpty(type) {
    const emptyTitle =
      type === 'TOPUP'
        ? 'You do not have records of any top up payments. Top up your Kick Credit to pay your purchases INSTANTLY and without any fees. Kick Credit also serves as a deposit when you make any offer on any products at Kick Avenue.'
        : 'You do not have records of any transaction';
    return (
      <div className={'empty-container'}>
        <KickImage src={EmptyList} />
        <p className={'empty-data'}>{emptyTitle}</p>
        <div className={'button-refresh'} onClick={onRefreshList}>
          <p>Refresh</p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <NotesCredit type={type} />
      <div className="pagination-wrapper d-block d-sm-none">
        {RenderPagination()}
      </div>
      <div className={'table-container'}>
        <div className={'header-table'}>
          <div className={'product-container'}>
            <span>Invoice No.</span>
          </div>
          <div className={'expiry-container'}>
            <span>Date</span>
          </div>
          <div className={'status-inprogress-container'}>
            <span>{type === 'TOPUP' ? 'Payment' : 'Status'}</span>
          </div>
        </div>
        {isFetching ? (
          <div className="text-center" style={{ padding: '2rem' }}>
            <div className="spinner-border text-success" />
          </div>
        ) : (
          <div className={'body-table'}>
            {data.length
              ? data.map((item) => renderItem(item))
              : renderEmpty(Details.type)}
          </div>
        )}
      </div>
      <ModalWalletLog
        title={title}
        icon={icon}
        isOpen={isModalDetailOpened}
        onToggle={toggleModalDetail}
        dataBank={Details.dataBank}
        disbursementNumber={Details.disbursementNumber}
        total_amount={Details.totalAmount}
        type={Details.type}
        paymentMethod={Details.paymentMethod}
        paymentVia={Details.paymentVia}
        invoiceNumber={Details.invoiceNumber}
        bankAccount={Details.bankAccount}
        invoiceUrl={Details.invoiceUrl}
        created_at={Details.created_at}
        expiredPayment={Details.expiredPayment}
        id={Details.id}
        fee={Details.fee}
        history={history}
        status={Details.status}
      />
    </div>
  );
}

export default BodyTab;
